import React, { useEffect, useState } from 'react';
import i18n from '../../services/i18n';
import { Confirmation } from '../notification/confirmation';
import { startVersionWatcher } from '../../utils/versionWatcher';
import './version-notifier.scss';

/**
 * Aviso de despliegue nuevo.
 *
 * Reutiliza el Confirmation de la app en vez de un modal propio: asi el aviso se
 * ve como cualquier otro dialogo del cliente (cabecera con icono, tipografia y
 * botones del sistema de diseno) y hereda su .confirmation-modal con z-index
 * 100003, que ya queda por encima del panel de los microfrontends (99999).
 *
 * Modal bloqueante a peticion de QA, pero NO recarga por su cuenta: el boton lo
 * pulsa el usuario cuando ha terminado lo que estuviera haciendo. Recargar por
 * sorpresa es lo que QA veto en 2026 y por lo que se retiro el versionChecker.
 *
 * "Mas tarde" no silencia para siempre: el watcher sigue vivo y volvera a avisar
 * si se despliega una version distinta de la ya notificada.
 */
const VersionNotifier = () => {
  const [change, setChange] = useState(null);

  useEffect(() => startVersionWatcher(setChange), []);

  // Marca el body mientras el aviso esta abierto: es lo que sube el backdrop por
  // encima del panel de los microfrontends (ver version-notifier.scss).
  useEffect(() => {
    if (!change) return undefined;
    document.body.classList.add('version-notifier-open');
    return () => document.body.classList.remove('version-notifier-open');
  }, [change]);

  if (!change) return null;

  return (
    <Confirmation
      initialModalState
      message={
        // Dos parrafos (peticion de producto). El Confirmation renderiza el
        // mensaje dentro de un <h5>, asi que se usan <span> en bloque —<p>
        // dentro de un heading no es HTML valido— con margen entre ambos.
        <>
          <span className="d-block">{i18n.t('version_notifier.message')}</span>
          <span className="d-block mt-3">{i18n.t('version_notifier.message_detail')}</span>
        </>
      }
      titleAccept={i18n.t('version_notifier.reload')}
      titleCancel={i18n.t('version_notifier.later')}
      confirmType="confirm-info"
      iconType="lf-icon lf-icon-information"
      onAccept={() => window.location.reload()}
      onCancel={() => setChange(null)}
    />
  );
};

export default VersionNotifier;
